module.exports = __webpack_public_path__ + "img/sld_abt_check_light.30006aae.svg";